// Override Shop Pay payment terms widget font
(function() {
  'use strict';

  // Function to inject styles into Shadow DOM
  function injectStylesIntoShadowDOM() {
    // Find all shopify-payment-terms elements
    const paymentTermsElements = document.querySelectorAll('shopify-payment-terms');

    paymentTermsElements.forEach(element => {
      // Access the shadow root
      const shadowRoot = element.shadowRoot;

      if (shadowRoot) {
        // Check if we've already injected styles
        if (!shadowRoot.querySelector('#custom-font-override')) {
          // Create a style element
          const styleElement = document.createElement('style');
          styleElement.id = 'custom-font-override';
          styleElement.textContent = `
            #shopify-installments,
            #shopify-installments *,
            #shopify-installments-content,
            #prequalAmountContainer,
            .font-system,
            p,
            span,
            * {
              font-family: var(--text-font-family) !important;
              font-size: var(--text-sm) !important;
              font-weight: var(--avoda-book) !important;
              letter-spacing: normal !important;
              line-height: 1.4 !important;
              color: var(--avoda-text-muted) !important;
            }
          `;

          // Append the style element to the shadow root
          shadowRoot.appendChild(styleElement);
        }
      }
    });
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectStylesIntoShadowDOM);
  } else {
    injectStylesIntoShadowDOM();
  }

  // Also observe for dynamically added elements
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeName === 'SHOPIFY-PAYMENT-TERMS') {
          // Wait a bit for the shadow DOM to be created
          setTimeout(injectStylesIntoShadowDOM, 100);
        }
      });
    });
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also try again after a delay in case the shadow DOM isn't ready immediately
  setTimeout(injectStylesIntoShadowDOM, 1000);
  setTimeout(injectStylesIntoShadowDOM, 2000);
})();